import { api } from "../../shared/api/axios";

export async function loginRequest({ email, senha }) {
  const { data } = await api.post("/auth/login", { email, senha });
  return data;
}
